import { useEffect } from "react";
import { useIpc, useIpcQuery } from "../../ipc/IpcProvider";
import { useAppStore } from "../../state/app-store";
import type { SyncConfig } from "../../ipc/types";

/**
 * Sincronización programada (item 6): mientras la app está abierta y la sincronización está
 * activada, cada N minutos importa órdenes y sincroniza precio/stock de todas las publicaciones.
 * Los resultados y fallos quedan en el centro de avisos. Sólo corre con la app abierta.
 *
 * Devuelve `reload` para que el panel de ajustes reprograme el temporizador tras guardar.
 */
export function useAutoSync(): { reload: () => void } {
  const client = useIpc();
  // syncNonce cambia al guardar la config → re-lee y reprograma el temporizador.
  const syncNonce = useAppStore((s) => s.syncNonce);
  const { state, reload } = useIpcQuery<SyncConfig>((c) => c.getSyncConfig(), [syncNonce]);
  const cfg = state.status === "ready" ? state.data : null;
  const enabled = cfg?.enabled ?? false;
  const intervalMinutes = cfg?.intervalMinutes ?? 30;

  useEffect(() => {
    if (!enabled) return;
    const ms = Math.max(1, intervalMinutes) * 60_000;
    const timer = setInterval(() => { void client.syncAll(); }, ms);
    return () => clearInterval(timer);
  }, [client, enabled, intervalMinutes]);

  return { reload };
}
